<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <h1 slot="title" class="mt-2 text-uppercase text-left font-weight-bold">Traslado Interplanta</h1>
      <b-row>
        <b-col cols="12">
          <b-card no-body>
            <form-wizard
              color="#0074d9"
              shape="circle"
              stepSize="sm"
              errorColor="#ff4136"
              ref="wizard"
              nextButtonText="Siguiente"
              backButtonText="Atrás"
              finishButtonText="Finalizar"
              @on-complete="handleFinish"
              title=""
              subtitle=""
            >
              <tab-content title="Ingrese datos de la guia de despacho" :before-change="checkStep1Validations">
                <step-1 ref="step1" :form="form"></step-1>
              </tab-content>
              <tab-content title="Seleccionar pallets a despachar">
                <step-2 ref="step2" :items="form.items" @update:items="form.items = $event"></step-2>
              </tab-content>
              <template slot="finish"
                ><b-button
                  size="lg"
                  variant="primary"
                  :disabled="loading"
                  class="wizard-footer-right finish-button font-weight-bold"
                  style="font-family: Arial"
                  >Finalizar</b-button
                ></template
              >
            </form-wizard>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Step1 from "./Step1.vue";
import Step2 from "./Step2.vue";
export default {
  name: "Traslados",
  components: {
    Step1,
    Step2
  },
  data() {
    return {
      loading: false,
      form: {
        id: null,
        clientCustomer: null,
        receiverPlant: null,
        emitterPlant: null,
        number: null,
        waybill_date: null,
        internal_note: null,
        note: "",
        license_plate: null,
        truck_driver: null,
        items: []
      }
    };
  },
  methods: {
    checkStep1Validations() {
      this.$refs["step1"].$v.form.$touch();
      if (this.$refs["step1"].$v.form.$anyError) {
        return false;
      } else {
        return true;
      }
    },
    handleFinish() {
      if (this.form.items.length <= 0) {
        this.$swal("Debe ingresar pallets a despacho", "", "warning");
        return false;
      } else {
        this.submit();
      }
    },
    async submit() {
      const thisV = this;
      thisV.loading = true;
      const url = "/api/v1/waybill/traslado_interplanta/";
      var payload = thisV.form;
      try {
        const response = await thisV.$axios.post(url, payload);
        thisV.loading = false;
        this.$router.push({ path: "/despacho/listado" });
        thisV.$swal("Operación realizada con éxito", JSON.stringify(response.data), "success");
      } catch (e) {
        console.log(e);
        thisV.loading = false;
        thisV.$swal("Ocurrió un error", "", "error");
      }
    }
  }
};
</script>

<style></style>
